// ============================================================
// Summit League v2 — Game Rules Router
// Route: /rules (game-scoped via subdomain)
// Located: src/pages/GameRules/GameRulesRouter.tsx
//
// Selects the correct rules page based on the current gameCode
// from the subdomain. Add new game rule components here as
// they're built.
// ============================================================

import React from 'react';
import { useGame } from '../../hooks/useGame';
import HaloInfinite4v4Rules from './HaloInfinite4v4Rules';
import Halo34v4Rules from './Halo34v4Rules';

const GameRulesRouter: React.FC = () => {
  const { gameCode, gameName } = useGame();

  switch (gameCode) {
    case 'hi':
      return <HaloInfinite4v4Rules />;

    case 'h3':
      return <Halo34v4Rules />;

    default:
      return (
        <div className="sl-profile-page" style={{ textAlign: 'center', paddingTop: '3rem' }}>
          <p style={{ color: 'rgba(148, 163, 184, 0.96)', fontSize: '0.95rem' }}>
            Rules for {gameName ?? 'this game'} are not yet available.
          </p>
        </div>
      );
  }
};

export default GameRulesRouter;